export default {"gitHash":"2e75e75b0ac8a4878a7ffc4126dca464747e3e05","gitHashShort":"2e75e75","time":1678850111431,"platform":"linux","arch":"x64"};